import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { CORP_BLUE, FONT_SIZE_UPLOAD } from 'config/config';
import { Download/* , Preview */ } from '@mui/icons-material';
import { obtenerArchivoPreviewAdjuntoPorSuper } from 'services/api';

const safeParse = (value) => {
  if (!value) return null;

  // Si ya es objeto, lo usamos tal cual
  if (typeof value === 'object') return value;

  // Si es string, intentamos parsear
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      console.warn('JSON inválido:', value);
      return null;
    }
  }

  return null;
};


const addStyle = makeStyles(theme => ({
  previewStyle: {
    color: 'black',
    cursor: 'pointer',
    padding: 2,
    '&:hover': {
      color: CORP_BLUE,
    },
  },

  gridRowItem: {
    fontSize: FONT_SIZE_UPLOAD,
    padding: 5,
  },
}));

const ViewHistoriaSuper = props => {
  const classes = addStyle();
  const { reclamo, setLoading, /* cargarPreviewSuper */ } = props;

  const getPreview = async (url, nombre) => {

    obtenerArchivoPreviewAdjuntoPorSuper(url)
      .then(r => {

        const link = document.createElement('a');
        link.href = r.data;
        link.setAttribute(
          'download',
          nombre + '.pdf',
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);


      })
      .catch(e => {
        console.error(e);
      })
      .finally(e => {
        setLoading(false);
      });


  };

  const startPreview = (item, nombre) => {
    setLoading(true);
    getPreview(item, nombre);
  };

  return (
    <Grid container>
      {reclamo !== null && reclamo !== undefined ? (
        reclamo.doc_adjunto_super ? (
          reclamo.doc_adjunto_super.length === 0 ? (
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <p>La Superintendencia de Salud no ha aportado Documentos.</p>
            </Grid>
          ) : (
            <Grid container>
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <p>Documentos aportados por la Superintendencia de Salud</p>
              </Grid>

              <Grid item xs={12}>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    style={{
                      height: 1,
                      backgroundColor: 'gray',
                      marginBottom: 5,
                      marginTop: 5,
                    }}
                  />
                  <Grid
                    item
                    container
                    xs={12}
                    alignItems="flex-start"
                    style={{ backgroundColor: CORP_BLUE, color: 'white' }}>
                    <Grid item xs={6} style={{ textAlign: 'start' }}>
                      <p style={{ fontSize: FONT_SIZE_UPLOAD, padding: 5 }}>Nombre Adjunto</p>
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: 'start' }}>
                      <p style={{ fontSize: FONT_SIZE_UPLOAD, padding: 5 }}>Fecha creación</p>
                    </Grid>
                    <Grid item xs={2} style={{ textAlign: 'center' }}>
                      <p style={{ fontSize: FONT_SIZE_UPLOAD, padding: 5 }}>Adjunto</p>
                    </Grid>
                  </Grid>
                  {reclamo !== null && reclamo !== undefined
                    ? reclamo.doc_adjunto_super.map((itemm, index) => {
                      const item = safeParse(itemm);
                      if (!item) return null;
                      return (
                        <Grid
                          key={index}
                          item
                          container
                          xs={12}
                          alignItems="flex-start"
                          style={{
                            backgroundColor: index % 2 === 0 ? '#ddddee' : 'whitesmoke',
                          }}>
                          <Grid item xs={6} style={{ textAlign: 'start' }}>
                            <p style={{ fontSize: FONT_SIZE_UPLOAD, padding: 5 }}>{item.nombre}</p>
                          </Grid>
                          <Grid item xs={4} style={{ textAlign: 'start' }}>
                            <p style={{ fontSize: FONT_SIZE_UPLOAD, padding: 5 }}>{item.fecha}</p>
                          </Grid>
                          <Grid item xs={2} style={{ textAlign: 'center' }}>
                            <Download
                              onClick={() => {
                                startPreview(item.link.trim(), item.nombre);
                              }}
                              className={classes.previewStyle}
                              style={{ fontSize: 34, padding: 2 }}
                            />
                          </Grid>
                        </Grid>
                      );
                    })
                    : null}
                  <Grid
                    item
                    xs={12}
                    style={{
                      height: 1,
                      backgroundColor: 'gray',
                      marginBottom: 5,
                      marginTop: 5,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          )
        ) : (
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <p>La Superintendencia de Salud no ha aportado Documentos.</p>
          </Grid>
        )
      ) : null}
    </Grid>
  );
};

export default ViewHistoriaSuper;
